import type { ViewQueryList, ViewQueryNode, ViewQueryRecordNode } from '@salescore/core'
import { isNotNullish, isNullish } from 'effect/Predicate'

import type { RSheetColumn, RSheetRecordNode } from '../../domain/column'
import { getNodePure } from '../../state/nodeUtility'

/**
 * 参照先のノードについて、参照元のノード (1 つ上のノード) のオブジェクトの名前を返す
 * - 参照先の選択や参照の解除は、参照元のレコードの参照項目を書き換えるため、編集権限は参照元のオブジェクトで判定する
 */
export const getReferencingModelName = ({
  node,
  query,
}: {
  node: Pick<ViewQueryNode, 'path'>
  query: Pick<ViewQueryList, 'tree'> | undefined
}): string | undefined => {
  if (isNullish(query)) {
    return undefined
  }
  return getNodePure(query.tree, node.path.slice(0, -1))?.write?.streamName
}

/**
 * セルを編集したときに値を書き込むオブジェクトの名前を返す
 * - 参照先のレコードがない虫眼鏡セルでは、選んだ参照先を参照元のレコードの参照項目に書き込むため、参照元のオブジェクトを返す
 * - それ以外は列の書き込み先を返す。書き込み先を持たない列は undefined
 * @param recordNode セルに表示しているレコード。レコードがない空のセルは undefined
 */
export const getEditTargetModelName = ({
  column,
  recordNode,
  query,
}: {
  column: Pick<RSheetColumn<RSheetRecordNode>, 'node' | 'nodeType' | 'field'>
  recordNode: ViewQueryRecordNode | undefined
  query: Pick<ViewQueryList, 'tree'> | undefined
}): string | undefined => {
  if (isNotNullish(recordNode) || column.nodeType !== 'parent') {
    return column.field?.write?.streamName
  }
  return getReferencingModelName({ node: column.node, query })
}
